export default __webpack_public_path__ + "static/media/Icon metro-bitcoin.b0bafbb2.svg";